import React, { ComponentProps, FunctionComponent } from "react";

const MuteIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 12",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.908405 0.240808L11.0677 9.89964L11.0722 9.89494L11.8955 10.6808L11.0669 11.5488L8.659 9.25039C8.07736 9.66956 7.38954 9.95502 6.64286 10.0611V12H5.35714V10.0611C3.17786 9.75158 1.5 7.91368 1.5 5.68421H2.78571C2.78571 6.52174 3.12436 7.32496 3.72716 7.91718C4.32995 8.5094 5.14752 8.8421 6 8.8421C6.61327 8.8421 7.20847 8.66992 7.71864 8.3528L6.75116 7.42932C6.51572 7.52714 6.26058 7.57895 6 7.57895C5.48851 7.57895 4.99797 7.37932 4.63629 7.02399C4.27462 6.66866 4.07143 6.18673 4.07143 5.68421V4.87146L0.103542 1.08402L0.908405 0.240808ZM4.09291 1.61265C4.15392 1.21452 4.34299 0.843111 4.63629 0.554956C4.99797 0.199624 5.48851 0 6 0C6.51149 0 7.00203 0.199624 7.36371 0.554956C7.72538 0.910288 7.92857 1.39222 7.92857 1.89474V5.25935L4.09291 1.61265ZM9.13021 6.40179L10.1577 7.37863C10.3782 6.85706 10.5 6.28485 10.5 5.68421H9.21429C9.21429 5.92775 9.18565 6.16839 9.13021 6.40179Z",
    })
  );
};

const ForwardRef = React.forwardRef(MuteIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
